import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { FormControl, Navbar, NavbarBrand, NavItem, NavbarHeader, NavDropdown, Nav, Container, Row, Button, Col, Form, Card, InputGroup } from 'react-bootstrap';

import ReactCountryFlag from "react-country-flag"
import carbonEodPricingInputs from '../json/carbonEodPricingInputs.json';


// Data from JSON or DB
const masterCountryList = {}
carbonEodPricingInputs[0].masterCountries.map(masterCountry => {
    const technologies = Object.keys(masterCountry.technologies)
    technologies.forEach((technology, index) => {
        masterCountryList[masterCountry.properties.iso3 + "_" + technology] = masterCountry.technologies[technology];
    })
})


function MarketsProducts(props) {
    // Setting original values (pick the prior day data from the DB or JSON file)
    const [state, setState] = useState(
        masterCountryList
    )

    // Show or hide card based on onClick event
    const [hidden, setHidden] = useState(true);

    const handleChange = evt => {
        const name = evt.target.name;
        const value =
            evt.target.type === "checkbox" ? evt.target.checked : evt.target.value;
        setState({
            ...state,
            [name]: value
        })

        // Passing all values to parent class
        props["jsonResponseGeoTech"]({ "name": name, "value": value });
    }



    return (
        <>
            <Card border="none" className="Card">
                <Card.Header className="Card-Header" style={{ cursor: 'pointer' }} onClick={() => setHidden(s => !s)}>Main markets & Products</Card.Header>
                {!hidden ? null :

                    <Card.Body className="Card-Body">
                        <div class="input-group flex-nowrap">
                            <div style={{ width: 25, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">&nbsp;</InputGroup>
                            </div>
                            <div style={{ width: 75, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">arabica</InputGroup>
                            </div>
                            <div style={{ width: 75, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">robusta</InputGroup>
                            </div>
                            <div style={{ width: 75, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">excelsa</InputGroup>
                            </div>
                            <div style={{ width: 75, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                <InputGroup size="sm" className="smaller-input">liberica</InputGroup>
                            </div>
                        </div>

                        {carbonEodPricingInputs[0].masterCountries.map(masterCountry =>
                            <div class="input-group flex-nowrap">

                                <div style={{ width: 25, marginLeft: 0, marginBottom: 0, fontSize: "var(--module-font-size)" }}>
                                    <InputGroup size="sm" className="smaller-input">
                                        <ReactCountryFlag
                                            countryCode={masterCountry.properties.iso2}
                                            svg
                                            style={{ width: '2em' }}
                                            title={masterCountry.properties.countryName}
                                        />
                                    </InputGroup>
                                </div>

                                <div style={{ width: 75, marginLeft: 0, marginBottom: 0 }}>
                                    <InputGroup size="sm" className="smaller-input">
                                        <FormControl name={masterCountry.properties.iso3 + "_arabica"} value={state[masterCountry.properties.iso3 + "_arabica"]} onChange={handleChange} type="number" step="0.05" />
                                    </InputGroup>
                                </div>

                                <div style={{ width: 75, marginLeft: 0, marginBottom: 0 }}>
                                    <InputGroup size="sm" className="smaller-input">
                                        <FormControl name={masterCountry.properties.iso3 + "_robusta"} value={state[masterCountry.properties.iso3 + "_robusta"]} onChange={handleChange} aria-label="Small" type="number" step="0.05" />
                                    </InputGroup>
                                </div>

                                <div style={{ width: 75, marginLeft: 0, marginBottom: 0 }}>
                                    <InputGroup size="sm" className="smaller-input">
                                        <FormControl name={masterCountry.properties.iso3 + "_excelsa"} value={state[masterCountry.properties.iso3 + "_excelsa"]} onChange={handleChange} aria-label="Small" type="number" step="0.05" />
                                    </InputGroup>
                                </div>

                                <div style={{ width: 75, marginLeft: 0, marginBottom: 0 }}>
                                    <InputGroup size="sm" className="smaller-input">
                                        <FormControl name={masterCountry.properties.iso3 + "_liberica"} value={state[masterCountry.properties.iso3 + "_liberica"]} onChange={handleChange} aria-label="Small" type="number" step="0.05" />
                                    </InputGroup>
                                </div>


                            </div>
                        )}


                    </Card.Body>
                }
            </Card>

        </>
    );

}


export default MarketsProducts;